var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgErotic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "url(#paint0_linear_6379_129231)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6379_129231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3073 14.5939C20.4791 12.2194 21.065 11.0322 21.9975 11.0322C22.9299 11.0322 23.5158 12.2194 24.6877 14.5939L25.0781 15.3849C25.42 16.0777 25.591 16.4241 25.8905 16.6417C26.1901 16.8594 26.5723 16.9149 27.3369 17.026L28.2099 17.1529C30.8302 17.5336 32.1403 17.724 32.4285 18.6108C32.7166 19.4976 31.7686 20.4217 29.8725 22.2699L29.2408 22.8857C28.6876 23.4249 28.411 23.6946 28.2965 24.0467C28.1821 24.3989 28.2474 24.7796 28.378 25.5411L28.5271 26.4105C28.9748 29.0202 29.1986 30.3251 28.4442 30.8732C27.6898 31.4213 26.518 30.8052 24.1743 29.573L23.3935 29.1625C22.7097 28.803 22.3677 28.6233 21.9975 28.6233C21.6272 28.6233 21.2853 28.803 20.6015 29.1625L19.8207 29.573C17.477 30.8052 16.3051 31.4213 15.5508 30.8732C14.7964 30.3251 15.0202 29.0202 15.4678 26.4105L15.6169 25.5411C15.7475 24.7796 15.8128 24.3989 15.6984 24.0467C15.584 23.6946 15.3074 23.4249 14.7541 22.8857L14.1225 22.2699C12.2264 20.4217 11.2783 19.4976 11.5665 18.6108C11.8546 17.724 13.1648 17.5336 15.7851 17.1529L16.6581 17.026C17.4226 16.9149 17.8049 16.8594 18.1044 16.6417C18.404 16.4241 18.5749 16.0777 18.9169 15.3849L19.3073 14.5939Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6379_129231",
    x1: 0,
    y1: 0,
    x2: 44,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA61F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6950E6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6379_129231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErotic);
export default __webpack_public_path__ + "static/media/erotic.1fc716d0.svg";
export { ForwardRef as ReactComponent };